import _ from "lodash";
import { getIn } from "formik";
import React from "react";

import { getAutomationDataAttr } from "../../../../../utils/automationUtils";
import {
  RadioGroup,
  RadioOld,
  Text,
  TextTypes,
  TextColors,
} from "../../../../../component-library";

import "./CareManagementFieldShared.styles.scss";
import "./CareManagementRadioField.styles.scss";

export const CareManagementRadioField = ({
  formikProps,
  isViewOnly,
  name,
  radioOptions = [],
  subTitle,
  testId,
  title,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <div className="CareManagementFieldShared--wrapper">
      <div className="CareManagementFieldShared--text_wrapper">
        <h3 className="CareManagementFieldShared--title">{title}</h3>
        <h3 className="CareManagementFieldShared--subTitle">{subTitle}</h3>
      </div>
      <div className="CareManagementRadioField--radio_wrapper">
        <RadioGroup
          className="CareManagementRadioField--radio_group"
          disabled={isViewOnly}
          name={title}
          onChange={handleChange}
          value={_.get(formikProps.values, name)}
        >
          {radioOptions.map((option, index) => {
            return (
              <RadioOld
                key={option.value || option.label || index}
                label={option.label}
                labelClassName="CareManagementRadioField--radio_label"
                radioClassName="CareManagementFieldShared--radio_button"
                value={option.value}
                {...getAutomationDataAttr(testId)}
              />
            );
          })}
        </RadioGroup>
        {errorMessage && isTouched && (
          <Text color={TextColors.red} layout="block" type={TextTypes.small}>
            {errorMessage}
          </Text>
        )}
      </div>
    </div>
  );
};
